import React, { useState, useEffect } from "react";
import Confetti from "react-confetti";
import "../App.css"; // You can define your CSS animations in this file
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";
import Lottie from "react-lottie";
import * as startAnimation from "../assets/startAnimationNew.json";

function Home() {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const [activeButton, setActiveButton] = useState(null);
  const [selectedLevel, setSelectedLevel] = useState("Beginner"); // Default level is set to 'Beginner'
  const [selectedLanguage, setSelectedLanguage] = useState(null); // Default language

  useEffect(() => {
    handleButtonClick("freePlay");
  }, []);

  // Function to handle level change
  const handleLevelChange = (event) => {
    setSelectedLevel(event.target.value);
  };

  // Function to handle language change
  const handleLanguageChange = (event) => {
    const language = event.target.value;
    setSelectedLanguage(language);
    if (language !== "Amaregna" && language !== "Afaan Oromoo" && language !== "Kiswahili" && language !== "Af Soomaali" && language !== "Tigrinya") {
      navigate("/in-development");
    }
  };

  // Function to start the game
  const startFreeGame = () => {
    localStorage.setItem("selectedGameType", "FreePlay");
  };
  const startTimedGame = () => {
    localStorage.setItem("selectedGameType", "TimedPlay");
  };
  const handleButtonClick = (mode) => {
    setActiveButton(mode);
    if (mode === "freePlay") {
      startFreeGame();
    } else if (mode === "timedPlay") {
      startTimedGame();
    }
  };

  const startGame = () => {
    if (!selectedLanguage) {
      alert('Please select a language before playing.');
      return;
    }
    else{
    localStorage.setItem("selectedLevel", selectedLevel);
      if (selectedLanguage === "Amaregna") {
        navigate("/GamePage");
      }else if (selectedLanguage === "Afaan Oromoo") {
        navigate("/GamePageOR");
      }else if (selectedLanguage === "Kiswahili") {
        navigate("/GamePageKI");
      }else if (selectedLanguage === "Af Soomaali") {
        navigate("/GamePageSO");
      }else if (selectedLanguage === "Tigrinya") {
        navigate("/GamePageTG");
      }
    }
  };
  // Function to goto about page
  const about = () => {
    navigate("/about-us");
  };
  const buttonStyle = {
    border: "none",
    width: "350px",
    height: "70px",
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: startAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Container>
      <Row>
        <h1 style={{ fontSize: "75px", marginTop: "100px" }}>Vocaps</h1>

        {/* <h4>Objective: </h4>
        <h6>This game is intended to improve language comprehension.</h6>
        <h4>Difficulty:</h4>
        <h6><b>Beginner</b> - Select the letter needed to complete the word from the options displayed.</h6>
        <h6><b>Intermediate</b> - Click on question mark and identify the correct row of the letter needed to complete the word displayed.</h6>
        <h6><b>Advanced</b> - Click on question mark and identify the missing letter/s to complete the word displayed.</h6> */}
      </Row>
      <Row>
        <div className="app-container">
          <div>
            <select
              onChange={handleLanguageChange}
              className="form-select mb-4"
            >
              <option
                value=""
                disabled
                selected
                style={{ textAlign: "center" }}
              >
                Select Language
              </option>
              <option value="Af Soomaali" style={{ textAlign: "center" }}>
              Af Soomaali
              </option>
              <option value="Afaan Oromoo" style={{ textAlign: "center" }}>
                Afaan Oromoo
              </option>
              <option value="Amaregna" style={{ textAlign: "center" }}>
                Amaregna{" "}
              </option>
              <option value="Kiswahili" style={{ textAlign: "center" }}>
                Kiswahili
              </option>
              <option value="Tigrinya" style={{ textAlign: "center" }}>
              Tigrinya
              </option>
            </select>
            <div>
              <button
                className="btn_start"
                style={{
                  marginRight: "10px",
                  marginBottom: "10px",
                  backgroundColor: activeButton === "freePlay" ? "#44b0ff" : "",
                  color: activeButton === "freePlay" ? "white" : "",
                }}
                onClick={() => handleButtonClick("freePlay")}
              >
                Free Style
              </button>
              <button
                className="btn_start"
                style={{
                  backgroundColor:
                    activeButton === "timedPlay" ? "#44b0ff" : "",
                  color: activeButton === "timedPlay" ? "white" : "",
                }}
                onClick={() => handleButtonClick("timedPlay")}
              >
                Timed Game
              </button>
            </div>

            {/* Level Selection Dropdown */}
            {/* <select onChange={handleLevelChange} className="form-select mb-4">
              <option selected>Game Level</option>
              <option value="Beginner">Beginner</option>
              <option value="Intermediate">Intermediate</option>
              <option value="Advanced">Advanced</option>
            </select> */}
            <button style={buttonStyle} onClick={startGame}>
              <Lottie
                options={defaultOptions}
                height={100}
                width={380}
                style={{ marginLeft: "-20px", marginTop: "-10px" }}
                isClickToPauseDisabled={true}
              />
            </button>
          </div>
        </div>
        <h3 style={{ marginTop: "-70px" }}>
          <button class="about-btn" onClick={about}>
            about game
          </button>
        </h3>
      </Row>
      <footer>
        <p>Vocaps ©{currentYear}.</p>
      </footer>
    </Container>
  );
}

export default Home;
